(function($) {

  	// DOM is fully loaded, safe to manipulate elements
  	$(function() {	

		const cardBlocksArr = document.querySelectorAll('.trusler-block--about-card');

		cardBlocksArr.forEach(block => {

			ParcelFunctions.inViewport(block, 0.3, 0.15, 'block-in-viewport');

		});				

	});

})(jQuery);